<template>
    <div>
        <div class="renew_box" v-if='showRenew'>
            <h3 class="tips">使用<common-data name="appShortName_26"/>软件，注册登录账号为：<span>{{ phone() }}</span>，请在下表勾选在该账号上欲续费的功能或数据授权：</h3>
            <template v-if='subAccounts.length > 0'>
                <p style='margin-bottom:10px;'>请在下方勾选欲续费的授权账号：</p>
                <check-box selectAll inline @change='accountChange'
                :data='subAccounts'></check-box>
            </template>
            <!-- <p style='margin-bottom:10px;font-size: 14px;'></p> -->
            <RenewAuthTable ref='authTable' @choose='tableChoose' :authData="authData" v-model="authPrice" :orderLimit='orderLimit' />
            <p v-show="selectshow || jgselectShow" style='margin-top:10px;'>请确认本次购买人身份：</p>
            <button v-show="selectshow" @click="exchange" class="arg_btn">{{argBtn}}</button>
            <div v-show="selectshow" class="argument" :class="{show: argBtn == '收起'}">
                <vue-scroll>
                    <div style='padding: 5px 10px;'>
                        <span>非专业用户是指包括1. 个人、自然人用户 2.
                            某些小型商业实体（有限责任公司、合伙、信托或法人），获得和使用市场数据（不包括任何场内交易数据），并受到下列限制的：</span><span
                            style="margin-top:15px;display: block;">非专业订阅人必须：<br>a.拥有一个活跃的期货交易账户；<br>b.是个人，自然人或小型商业实体；</span><span
                            style="margin-top:15px;display: block;">非专业用户必须不能是：<br>c.任何交易所的会员（亦不得拥有或租用任何交易所的任何一类会员资格）；<br>d.在任何证券交易所、商品交易所、期货交易所、合约市场或者任何监管机构、专业协会或经过任何的专业机构登记或获得资格认证的专业交易员或投资顾问；<br>e.作为一个机构的代表从事经济业务，银行业，投资业或其他金融活动；</span><span
                            style="margin-top:15px;display: block;">非专业用户使用信息：<br>f.仅为用户本人使用；<br>g.不应超出用户本人所能管理的资产，不能和任何第三方有任何资产的联系；</span><span
                            style="margin-top:15px;display: block;">非专业用户获取信息：<br>h.从每一经销商处获取市场资料的渠道可以有两（2）条,并且订阅人须在能将订单传送到交易所电子交易平台的设备（“订单传送设备”）上浏览市场数据。</span><span>订单传送设备：有权接收实时信息，并能够向CME
                            Globex电子交易平台传送指令的交易终端。</span><span
                            style="margin-top:15px;display: block;">不符合非专业用户资格条件的任何订阅人，均应被视为专业用户。</span><span
                            style="display: block;margin-bottom:15px;">不管本档中有何规定，在各种情况下，交易所均保留对某一订阅人是非专业用户还是专业用户作出最终认定的权利，交易所保留随时修订本政策或者终止对非专业用户减低收费标准的做法的权利。</span><span
                            style="display: block;">请选择您的类别，然后本文档将被文华财经保存，备交易所随时审查。<br>请注意，如果订阅人不再符合非专业用户的资格条件，则其必须在合理可行的范围内尽快通知文华财经。</span>
                    </div>
                </vue-scroll>
            </div>

            <div class="selectItem" v-show="selectshow" :class="{active: index == chooseIndex && chooseIndex != null}"
                @click="choose(item,index)" v-for="(item,index) in selectList" :key="index">
                <i></i>
                {{item}}
            </div>

            <p v-show='jgselectShow' style='margin-top:20px;margin-bottom:5px;'>香港数据针对个人用户和公司用户数据授权费不同</p>
            <div class="selectItem" v-show='jgselectShow'
                :class="{active: index == jgChooseIndex && jgChooseIndex != null}" @click="jgChoose(item,index)"
                v-for="(item,index) in jgSelectList" :key="'x'+index">
                <i></i>
                {{item}}
            </div>
            <div class="cut-line"></div>
            <p class="little-label">支付方式:</p>
            <AuthChooseItem v-for='(item) in deadLine' :key='item.name' :name='item.name' @click='chooseLimit(item)' :selected='item.selected' :disable='item.disable ||  $route.name == "Preview"'/>
        </div>
    </div>
</template>

<script>
    import RenewAuthTable from './RenewAuthTable.vue'
    const triggerOnce = wh.triggerOnce()
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'renew',
        components: {
            RenewAuthTable
        },
        inject: ['phone','freshPriceData','tabToAdd','renewValidCross', 'changeAuthPrice', 'buy', 'changeMainPrice','setMultipleAccounts','orderByMonth','orderByYear', 'orderByQuarter','orderByCancel','setRenewBuyValidState', 'setLoading'],
        props: {
            whProduct: {
                type: Array,
                default: () => ([])
            }
        },
        data: () => ({
            user: '',
            authData: [],
            authPrice: 0,
            showRenew: false,
            user: '',
            password: '',
            showLogin: true,
            argBtn: '根据CME关于专业和非专业用户的规定',
            chooseIndex: null,
            jgChooseIndex: null,
            chooseLimitIndex: 1,
            selectList: ['本人确认，本人符合非专业用户资格', '本人确认，本人符合专业用户资格'],
            jgSelectList: ['本人特此确认，本人是个人用户', '本人特此确认，本人是公司用户'],
            argumentName: '根据CME关于专业和非专业用户的规定',
            jgselectShow: false,
            selectshow: false,
            subAccounts: [],
            canOrderByMonth: false,
            deadLine: [
                {
                    name: '按年支付',
                    value: 1,
                    selected: true,
                    disable: false
                },
                {
                    name: '按季支付',
                    value: 2,
                    selected: false,
                    disable: false
                }
            ],
            price: 0,
            monthprice: 0,
            quarterprice: 0,
            isDanAuthorization: false,
            memoryAuthSelections: [],
            isMonthPay: false,
            isQuarterPay: false,
            productId: ''
        }),
        computed: {
            
            selectIds() {
                return this.$refs.authTable.selectIds
            },
            orderLimit () {
                let target = this.deadLine.find(v=>v.selected)
                if (target) {
                    return target.value
                } else {
                    return -1
                }
            },
            hasHistoryData () {
                return this.$refs.authTable.selectHistory
            }
        },
        watch: {
            authPrice: {
                handler(val) {
                    this.changeAuthPrice(val)
                },
                immediate: true
            },
            chooseIndex(val) {
                if (val != null) {
                    let data = this.$store.state.renewbuy.fetchInfo
                    data.ismajor = val
                    this.$store.commit('renewbuy/setInfo', data)
                }
            },
            jgChooseIndex(val) {
                if (val != null) {
                    let data = this.$store.state.renewbuy.fetchInfo
                    data.isjg = val
                    this.$store.commit('renewbuy/setInfo', data)
                }
            }
        },
        mounted() {
            if (!this.productId) {
                this.productId = this.$route.params.id
            }
        },
        methods: {
            async init (res) {
                this.clear()
                if (!res.data.status) {
                    this.tabToAdd()
                }
                let self = this
                this.deadLine = [
                    {
                        name: '按年支付',
                        value: 1,
                        selected: true,
                        disable: false
                    },
                    {
                        name: '按季支付',
                        value: 2,
                        selected: false,
                        disable: false
                    }
                ]
                this.$store.commit('renewbuy/setQuarterMode', false)
                if (res.data.status) {
                    self.changeMainPrice(res.data.result.product.price)
                    self.canOrderByMonth = res.data.result.product.monthprice > 0 && res.data.result.product.monthprice != res.data.result.product.price && (res.data.result.sublist.length == 0 || !res.data.result.sublist) /*&& (!res.data.result.sublist.some(v=>v.productName != "多账号下单模块"))*/
                    self.price = res.data.result.product.price
                    self.monthprice = res.data.result.product.monthprice
                    self.quarterprice = res.data.result.product.quarterprice
                    self.isQuarterPay = res.data.result.product.isQuarterPay
                    self.isMonthPay = res.data.result.product.isMonthPay
                    if (res.data.result.isDanAuthorization) {
                        res.data.result.sublist = res.data.result.sublist.filter(v=>v.sale)
                        self.$store.commit('renewbuy/setInfo', res.data)
                        self.changeMainPrice(0) //如果单授权续费，主价格显示为0
                        self.isDanAuthorization = true
                        renewshow(true)
                    } else {
                        var isDzh = await new Promise((resolve, reject) => {
                            if (res.data.isDzh) {
                                this.$market.agree({
                                    agreeBtn: "确定",
                                    cancelBtn: '取消',
                                    content: '您有批量购买多个授权账号，是否需要同时续费？',
                                    agreeCall() {
                                        resolve(true)
                                    },
                                    degreeCall() {
                                        resolve(false)
                                    }
                                })
                            } else {
                                resolve(false)
                            }
                        })
                        if (isDzh) {
                            this.$axios({
                                url: "/api/Product/GetOrderIdAccList?clientid="+res.data.user.xzh+'&dzh='+res.data.user.dzh+'&producttype='+res.data.productType+'&pid='+self.productId,
                                method: "get"
                            }).then(dat =>{
                                if (dat.status) {
                                    let cloneData = JSON.parse(JSON.stringify(res.data))
                                    
                                    let unSales = dat.data.data.productsub.filter(v=>!v.sale)
                                    if (unSales.length > 0) {
                                        // this.$market.alert({
                                        //     btnTxt: "已知晓",
                                        //     content: `您续费账号中的${unSales.map(v=>v.productName).join(',')}授权已停售！`
                                        // })
                                    }
                                    cloneData.result.sublist = dat.data.data.productsub.filter(v=>v.sale)

                                    self.$store.commit('renewbuy/setInfo', cloneData)
                                    self.subAccounts = dat.data.data.accounts.split(',').map(v=>({label:v,value:v}))
                                    renewshow(false,cloneData)
                                }
                            })
                        } else {
                            res.data.result.sublist = res.data.result.sublist.filter(v=>v.sale)
                            self.$store.commit('renewbuy/setInfo', res.data)
                            renewshow(false)
                        }
                        
                    }
                    function renewshow(isDan,data) {
                        
                        self.showRenew = true
                        self.showLogin = false
                        self.renewValidCross(true) //通知上层组件，续费验证通过了
                        data = data ? data.result : res.data.result

                        //数据准备//
                        data.sublist.forEach(async item => {
                            let obj = {
                                ...item,
                                _exist: false
                            }
                            if (item.productlink.indexOf('EUREX') >= 0 || item.productName
                                .indexOf('香港') >= 0) {
                                if (res.data.isjg || res.data.isjg === 0) {
                                    obj._ismajor = res.data.isjg
                                    obj._selected = true
                                } else {
                                    obj._ismajor = null
                                    obj._selected = false
                                }
                            }
                            else {
                                if (!data.ismajor && data.ismajor != 0) {
                                    obj._ismajor = null
                                    obj._selected = false
                                } else {
                                    obj._ismajor = data.ismajor
                                    obj._selected = true
                                    //如果用户同时可以选择上海五档的两个交易所数据，那么这两个都不勾选，2021-10-8柏慧加
                                    if (item.id == 348 || item.id == 170) {
                                        obj._selected = false
                                    }
                                }
                            }
                            if (item.right_end_date == '已过期') {
                                obj._selected = false
                            }
                            self.authData.push(obj)
                        })
                        self.chooseIndex = res.data.ismajor == 1 ? 1 : 0
                        self.jgChooseIndex = res.data.isjg == 1 ? 1 : 0


                        let eurex = data.sublist.find(v => v.productlink.indexOf('EUREX') >=
                            0) //判断续费授权中是否有欧交所
                        let hk = data.sublist.find(v => v.productName.indexOf('香港') >=
                            0) //判断续费授权中是否有香港
                        if (eurex || hk) {
                            self.jgselectShow = true //有欧交所就显示个人机构的选择
                        }

                        let out = data.sublist.find(v => v.price != v.majorprice && v.productName.indexOf('香港') < 0) //判断续费授权中是否有外盘（两个价格不等）
                        if (out) {
                            self.selectshow = true //有外盘则显示专业非专业的选择
                        }
                        self.$nextTick(() => {
                            self.changeAuthPrice(self.authPrice)
                        })
                    }

                } else {
                    self.$market.alert({
                        content: res.data.message
                    })
                }
            },
            accountChange (val) {
                //设置父组件上的小账号值
                this.setMultipleAccounts(val)
            },
            backToLogin() {
                this.user = ''
                this.password = ''
                this.showRenew = false
                this.showLogin = true
                this.jgselectShow = false
                this.selectshow = false
                this.chooseIndex = null
                this.jgChooseIndex = null
                this.authData = []
                this.renewValidCross(false) //通知上层组件，续费验证取消
                this.setMultipleAccounts([]) //通知上层组件，重置小账号的值
                this.subAccounts = []
                this.deadLine = [
                    {
                        name: '按年支付',
                        value: 1,
                        selected: true,
                        disable: false
                    }
                ]
                
                this.canOrderByMonth = false
                this.price = 0
                this.monthprice = 0
                this.isDanAuthorization = false
                this.memoryAuthSelections = []
                this.orderByCancel()
            },
            exchange() {
                if (this.argBtn == this.argumentName) {
                    this.argBtn = '收起'
                } else {
                    this.argBtn = this.argumentName
                }
            },
            choose(item, index) {
                this.chooseIndex = index
                if (index == 0) {
                    this.$refs.authTable.setUnMajorAll()
                } else if (index == 1) {
                    this.$refs.authTable.setMajorAll()
                }
            },
            jgChoose(item, index) {
                this.jgChooseIndex = index
                if (index == 0) {
                    this.$refs.authTable.setNotJg()
                } else if (index == 1) {
                    this.$refs.authTable.setJg()
                }
            },
            tableChoose(next, item, index) {
                if (this.chooseIndex == null) {
                    return this.$market.alert({
                        content: '请先在下方选择您的身份'
                    })
                }
                if (item.productlink && item.productlink.indexOf('EUREX') < 0 && item.productName.indexOf('香港') < 0) {
                    let selectOut = this.$refs.authTable.selectOut
                    if (selectOut.length == 1 && selectOut[0].id == item.id) {
                        this.selectshow = false
                    } else if (selectOut.length == 0 && item.price != item.majorprice) {
                        this.selectshow = true
                    }
                }
                let needJGChoose = item.productlink && (item.productlink.indexOf('EUREX') >= 0 || item.productName
                    .indexOf('香港') >= 0) && item.price != item.majorprice
                if (needJGChoose) {
                    if (this.jgChooseIndex == null) {
                        return this.$market.alert({
                            content: '请先在下方选择您的身份'
                        })
                    }
                    let selectEUREX = this.$refs.authTable.selectEUREX
                    let allJgData = this.authData.filter(v => (v.productlink.indexOf('EUREX') >= 0 || v.productName
                        .indexOf('香港') >= 0) && (v.majorprice != v.price))
                    if (selectEUREX.length == allJgData
                        .length) { //selectEUREX.length == 1 && selectEUREX[0].id == item.id
                        this.jgselectShow = false
                    } else {
                        this.jgselectShow = true
                    }
                }
                next(item, index)
            },
            async chooseLimit (item) {
                if (item.selected) return
                if (item.value == 1) {
                    this.chooseLimitIndex = 1
                    //按年购买
                        this.deadLine.forEach(v=>{
                            if(v.value == item.value) {
                                this.$set(v,'selected',true)
                            } else {
                                this.$set(v,'selected',false)
                            }
                        })
                        this.$store.commit('renewbuy/setQuarterMode', false)
                        this.orderByYear(this.price)
                        // if (this.memoryAuthSelections.length > 0) {  //如果之前有记录过的子授权，重新将其选中，并清除记录
                        //     this.memoryAuthSelections.forEach(item => {
                        //         this.$refs.authTable.selectItemByMemory(item)
                        //     })
                        //     //设置是否专业和是否机构
                        //     if (this.chooseIndex == 0) {
                        //         this.$refs.authTable.setUnMajorAll()
                        //     } else if (this.chooseIndex == 1) {
                        //         this.$refs.authTable.setMajorAll()
                        //     }

                        //     if (this.jgChooseIndex == 0) {
                        //         this.$refs.authTable.setNotJg()
                        //     } else if (this.jgChooseIndex == 1) {
                        //         this.$refs.authTable.setJg()
                        //     }
                        // }
                        this.freshPriceData(1, false)
                } else if(item.value == 2) {
                    //按月购买
                    
                    this.chooseLimitIndex = 2
                    this.deadLine.forEach(v=>{
                        if(v.value == item.value) {
                            this.$set(v,'selected',true)
                        } else {
                            this.$set(v,'selected',false)
                        }
                    })
                    // if (this.memoryAuthSelections.length <= 0) {
                    //     this.memoryAuthSelections = wh.disDeepClone(this.$refs.authTable.getSelections()/*.filter(v=> v.productName != "多账号下单模块")*/)//保存切换之前选中的授权项
                    // }
                    this.$store.commit('renewbuy/setQuarterMode', true)
                    this.orderByQuarter(this.quarterprice)
                        
                    this.freshPriceData(1, true)
                }
            },
            hasOut() {
                return this.showRenew ? this.$refs.authTable.hasOut : false
            },
            clear() {
                this.authData = []
            },
            fromWh10SetOnceUser (user) {
                triggerOnce(()=>{
                    //从wh10客户端来的界面，运行进程期间，只在第一次进入的时候触发设置user
                    this.user = user
                })
            },
            setPriceByItem (item) {
                this.$refs.authTable.setPriceByItem(item)
            }
        }
    }
</script>

<style scoped>
    .login_box {
        padding: 20px 0;
    }

    .forget_pwd {
        color: rgb(6, 96, 172);
        font-size: 12px;
        margin-left: 5px;
        position: relative;
        top: 5px;
    }

    .login_box .line {
        position: relative;
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        padding: 4px 0;
    }

    .login_box .line input {
        width: 95px;
        border: 1px solid rgb(202, 202, 203);
        background: white;
        margin: 0 3px;
        border-radius: 2px;
        height: 25px;
        line-height: 25px;
        outline: 0;
        padding-left: 10px;
    }

    .renew_box {
        padding-bottom: 20px;
    }

    .blue_btn {
        background: rgb(6, 96, 172);
        color: white;
        font-size: 12px;
        border: 0;
        border-radius: 3px;
        padding: 5px 10px;
        outline: 0;
    }

    .back_btn {
        color: rgb(60, 141, 237);
        text-decoration: underline;
        border: 0;
        background: transparent;
        cursor: pointer;
        padding-left: 20px;
        outline: none;
        background: url(../../../assets/image/fanhui.png) no-repeat left;
        padding-left: 20px;
    }

    .tips {
        /* color: rgb(96, 69, 33); */
        font-size: 14px;
        font-weight: normal;
    }

    

    .arg_btn {
        background: transparent;
        border: 0;
        outline: 0;
    }

    .argument {
        color: #7c7c7c;
        max-height: 200px;
        height: 0;
        overflow: hidden;
        overflow-y: auto;
        background: #e0edfd;
        margin-bottom: 10px;
        transition: height .3s;
    }

    .argument.show {
        height: 200px;
    }

    .arg_btn {
        color: #1261D2;
        text-decoration: underline;
        cursor: pointer;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .selectItem {
        cursor: default;
    }

    .selectItem i {
        display: inline-block;
        width: 15px;
        height: 17px;
        vertical-align: middle;
        background: url(../../../assets/image/choose_01_y.png) no-repeat center;
    }

    .selectItem.active i {
        background: url(../../../assets/image/choose_01_y22.png) no-repeat center;
    }
    .little-label{
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 0 0 4px;
        margin: 0;
    }
    
    .cut-line {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }
    
    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }
</style>